import React from 'react';
import { Typography, Paper, Divider, Box } from '@mui/material';
import { ReactComponent as Logo } from '../asset/logo.svg';

// Utility to add thousand separators
const addThousandsSeparator = x =>
  x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');

const Comprobante = ({ order }) => {
  const orderData = order.order;
  const discount = orderData.DiscountCode;

  // Subtotal bruto (sin descuento ni envío)
  const subtotal = orderData.Order_Items.reduce(
    (acc, cur) =>
      acc +
      (cur.Variant.price + cur.Addition_Items.reduce((a, c) => a + c.price, 0)) *
        cur.quantity,
    0
  );

  // Determinar monto y etiqueta de descuento
  let discountAmount = 0;
  let discountLabel = '';
  if (discount) {
    if (discount.discountPercentage != null) {
      // Descuento porcentual
      discountAmount = Math.round(subtotal * (discount.discountPercentage / 100));
      discountLabel = `${discount.name} (${discount.discountPercentage}%)`;
    } else if (discount.discountAmount != null) {
      // Descuento monto fijo
      discountAmount = discount.discountAmount;
      discountLabel = discount.name;
    }
  }

  const shippingCost = orderData.shippingCost;
  const totalAmount = subtotal - discountAmount + shippingCost;

  return (
    <Paper>
      <Box sx={{ p: 3, fontFamily: 'Bellota', display: 'flex', flexDirection: 'column', gap: 2 }}>

        {/* Header */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'center' }}>
          <Logo style={{ height: 100, width: 'auto' }} />
          <Typography sx={{ fontWeight: 'bold', fontSize: 18 }}>Comprobante de Pago</Typography>
        </Box>

        {/* Datos de la orden */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Box sx={{ display: 'flex' }}>
            <Typography sx={{ fontWeight: 'bold', minWidth: 120 }}>Orden:</Typography>
            <Typography>{orderData.idSellOrder}</Typography>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <Typography sx={{ fontWeight: 'bold', minWidth: 120 }}>Fecha:</Typography>
            <Typography>{new Date(order.date).toLocaleString('es-CL')}</Typography>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <Typography sx={{ fontWeight: 'bold', minWidth: 120 }}>Despacho:</Typography>
            <Typography>
              {orderData.deliveryType}{' '}
              {orderData.deliveryType === 'Despacho a Domicilio' ? '(40–60 min)' : '(15–25 min)'}
            </Typography>
          </Box>
          {orderData.deliveryType === 'Despacho a Domicilio' && (
            <Box sx={{ display: 'flex' }}>
              <Typography sx={{ fontWeight: 'bold', minWidth: 120 }}>Dirección:</Typography>
              <Typography>{orderData.address}</Typography>
            </Box>
          )}
          {orderData.additionalInfo && (
            <Box sx={{ display: 'flex' }}>
              <Typography sx={{ fontWeight: 'bold', minWidth: 120 }}>Instrucciones:</Typography>
              <Typography>{orderData.additionalInfo}</Typography>
            </Box>
          )}
        </Box>

        {/* Detalle de ítems */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
          <Typography sx={{ fontWeight: 'bold', fontSize: 18 }}>Detalle de ítems:</Typography>

          {orderData.Order_Items.map(item => (
            <Box key={item.SellOrderIdSellOrder} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>

              {/* Fila principal de cada ítem */}
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography sx={{ width: 30 }}>x{item.quantity}</Typography>
                <Typography sx={{ flex: 1, fontWeight: 'bold' }}>
                  {item.Variant.Product.name} – {item.Variant.name}
                  {item.modifier ? ' (Precocida)' : ''}
                </Typography>
                <Typography sx={{ width: 80, textAlign: 'right' }}>
                  ${addThousandsSeparator(item.Variant.price * item.quantity)}
                </Typography>
              </Box>

              {/* Agregados */}
              {item.Addition_Items.length > 0 && (
                <Box sx={{ pl: 4, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                  {item.Addition_Items.map(add => (
                    <Box key={add.idAdditionItems} sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography variant="body2" sx={{ width: 20, color: 'text.secondary' }}>+</Typography>
                      <Typography variant="body2" sx={{ flex: 1, color: 'text.secondary' }}>{add.name}</Typography>
                      <Typography variant="body2" sx={{ width: 60, textAlign: 'right', color: 'text.secondary' }}>
                        ${addThousandsSeparator(add.price)}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              )}

            </Box>
          ))}
        </Box>

        {/* Separador */}
        <Divider />

        {/* Totales */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'flex-end', mt: 2 }}>
          <Box sx={{ display: 'flex' }}>
            <Typography sx={{ minWidth: 120 }}>Subtotal:</Typography>
            <Typography>${addThousandsSeparator(subtotal)}</Typography>
          </Box>

          {discount && (
            <Box sx={{ display: 'flex' }}>
              <Typography sx={{ minWidth: 120 }}>{discountLabel}:</Typography>
              <Typography>-${addThousandsSeparator(discountAmount)}</Typography>
            </Box>
          )}

          <Box sx={{ display: 'flex' }}>
            <Typography sx={{ minWidth: 120 }}>Despacho:</Typography>
            <Typography>${addThousandsSeparator(shippingCost)}</Typography>
          </Box>

          <Box sx={{ display: 'flex', fontWeight: 'bold' }}>
            <Typography sx={{ minWidth: 120 }}>Total:</Typography>
            <Typography>${addThousandsSeparator(totalAmount)}</Typography>
          </Box>
        </Box>

      </Box>
    </Paper>
  );
};

export default Comprobante;

